import { render, staticRenderFns } from "./CompoundHealthActionCard.vue?vue&type=template&id=78e649ce"
import script from "./CompoundHealthActionCard.vue?vue&type=script&lang=js"
export * from "./CompoundHealthActionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports